const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/deviceActions.ts';

import { DeviceOrientation, DeviceType } from '@cistec/common_web/defs/device';

// define possible actions that will be triggered by this action creator
export const DEVICESCREEN_CHANGED = 'DEVICESCREEN_CHANGED';

/**
 * Action to emit after the screen of the device changed which sets the screen parameters dimensions of the device
 */
export function deviceScreenChanged(windowObj: any) {
    const payload: any = {
        width: windowObj.innerWidth,
        height: windowObj.innerHeight,
        orientation: DeviceOrientation.LANDSCAPE,
    };

    if ((1.0 * payload.width) / payload.height < 1.25) {
        payload.orientation = DeviceOrientation.PORTRAIT;
    }

    return (dispatch: any, getState: any) => {
        const device = getState().device.get('type');

        // Currently, Safari mobile does not support this, but for keyboards Safari doesn't change the body area so
        // the heuristic above should be good enough. On desktops if available it would always report landscape so we
        // fall back on the same heuristic as for mobile safari
        const orientation: any =
            (windowObj as any).screen.orientation ||
            (windowObj as any).screen.mozOrientation ||
            (windowObj as any).screen.msOrientation;
        if (orientation !== undefined && device !== DeviceType.DESKTOP) {
            if (orientation.type.startsWith('portrait-')) {
                payload.orientation = DeviceOrientation.PORTRAIT;
            }
            if (orientation.type.startsWith('landscape-')) {
                payload.orientation = DeviceOrientation.LANDSCAPE;
            }
        }

        dispatch({ type: DEVICESCREEN_CHANGED, payload });
    };
}
